import * as bootstrapGlob from 'bootstrap';
var bootstrap = bootstrapGlob;
export default (window.bootstrap = bootstrapGlob);
